import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  pageWrapper: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f5f7fa",
  },
  loginContainer: {
    display: "flex",
    width: "100%",
    maxWidth: "1000px",
    minHeight: "600px",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    margin: "20px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      maxWidth: "450px",
    },
  },
  brandingPanel: {
    flex: "1",
    backgroundColor: "#324D54",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 24px",
    },
  },
  brandingContent: {
    textAlign: "center",
    color: "#ffffff",
  },
  logo: {
    width: "120px",
    height: "120px",
    marginBottom: "24px",
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    padding: "8px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    [theme.breakpoints.down("sm")]: {
      width: "80px",
      height: "80px",
      marginBottom: "16px",
    },
  },
  brandTitle: {
    fontSize: "2.5rem",
    fontWeight: "800",
    letterSpacing: "4px",
    marginBottom: "8px",
    color: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.8rem",
    },
  },
  brandTagline: {
    fontSize: "1rem",
    color: "rgba(255, 255, 255, 0.8)",
    marginBottom: "32px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "20px",
      fontSize: "0.9rem",
    },
  },
  featureList: {
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  featureItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "12px",
    fontSize: "0.95rem",
    color: "rgba(255, 255, 255, 0.9)",
  },
  featureIcon: {
    width: "24px",
    height: "24px",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    color: "#4ade80",
  },
  formPanel: {
    flex: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px",
    backgroundColor: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 24px",
    },
  },
  formContainer: {
    width: "100%",
    maxWidth: "360px",
  },
  formHeader: {
    marginBottom: "32px",
    textAlign: "center",
  },
  formTitle: {
    fontSize: "1.75rem",
    fontWeight: "700",
    color: "#1a1a1a",
    marginBottom: "8px",
  },
  formSubtitle: {
    fontSize: "0.95rem",
    color: "#666666",
  },
  form: {
    width: "100%",
    "& .MuiTextField-root": {
      marginBottom: "16px",
    },
    "& .MuiFilledInput-root": {
      backgroundColor: "#f5f7fa",
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: "#eef1f5",
      },
      "&.Mui-focused": {
        backgroundColor: "#eef1f5",
      },
    },
    "& .MuiFilledInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiFilledInput-underline:after": {
      borderBottom: "2px solid #324D54",
    },
    "& .MuiInputLabel-filled": {
      color: "#666666",
    },
    "& .MuiInputLabel-filled.Mui-focused": {
      color: "#324D54",
    },
    "& .MuiFilledInput-input": {
      color: "#1a1a1a",
    },
  },
  forgotPassword: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    marginTop: "12px",
    marginBottom: "24px",
  },
  /** Pill-style actions under password (Forgot password + optional Forget device) */
  authActionPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "7px 14px",
    borderRadius: "999px",
    fontSize: "0.8125rem",
    fontWeight: 600,
    letterSpacing: "0.01em",
    textDecoration: "none",
    border: "1.5px solid #c5d4d8",
    backgroundColor: "#f4f8f9",
    color: "#2a4248",
    transition:
      "background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease",
    boxShadow: "0 1px 3px rgba(50, 77, 84, 0.08)",
    "&:hover": {
      backgroundColor: "#ff8989",
      borderColor: "#324D54",
      color: "#ffffff",
      boxShadow: "0 3px 10px rgba(50, 77, 84, 0.14)",
    },
  },
  authActionPillTrust: {
    borderColor: "#b8c5c9",
    backgroundColor: "#fafcfb",
    color: "#3d5a62",
    "&:hover": {
      backgroundColor: "#eef6f4",
      borderColor: "#2d6a4f",
      color: "#1b4332",
    },
  },
  authActionPillIcon: {
    fontSize: "1.05rem",
    opacity: 0.92,
  },
  authPillButton: {
    fontFamily: "inherit",
    cursor: "pointer",
  },
  submitButton: {
    backgroundColor: "#324D54",
    color: "#ffffff",
    padding: "14px 24px",
    fontSize: "1rem",
    fontWeight: "600",
    borderRadius: "8px",
    textTransform: "none",
    boxShadow: "0 4px 14px rgba(50, 77, 84, 0.3)",
    "&:hover": {
      backgroundColor: "#263b40",
      boxShadow: "0 6px 20px rgba(50, 77, 84, 0.4)",
    },
  },
  footer: {
    marginTop: "32px",
    textAlign: "center",
  },
  footerText: {
    fontSize: "0.75rem",
    color: "#999999",
  },
  // Legacy styles kept for compatibility
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  googleButton: {
    marginBottom: theme.spacing(2),
  },
}));
